import React from "react";
import { map, filter, flatten } from "lodash";

import { tableStyle, tableLabelStyle } from "./styles";
import { moneyFormatM } from "./format";

export const populateKeys = (groups, values) =>
  map(groups, group => ({
    ...group,
    rows: filter(
      map(group.rows, el => ({
        ...el,
        value: el.fn ? el.fn(values) : values[el.key || el.label]
      })),
      ({ value }, index, rows) => value !== 0 || index === rows.length - 1
    )
  }));

const formatSpecific = (value, label) => {
  if (label === "Holding Expenses" && value >= -1 && value <= 1) {
    return value < 0 ? "-$0.000 M" : "$0.000 M";
  }

  const shortValue = Math.abs(Number((value / 1e6).toFixed(3)));
  if (shortValue === 0) {
    return value < 0 ? "-$0.000 M" : "$0.000 M";
  }

  return moneyFormatM(value);
};

const MoneyTable = ({ keys }) => (
  <table style={tableStyle}>
    <tbody>
      {flatten(
        map(keys, ({ group, rows }) =>
          map(rows, ({ label, key, value, withoutValue }, index) => [
            <tr
              style={{
                height: "2.2em"
              }}
              key={label}
            >
              {index === 0 ? (
                <td rowSpan={rows.length} style={tableLabelStyle}>
                  {group}
                </td>
              ) : null}
              <td
                style={{
                  width: "100%",
                  paddingRight: "2ch",
                  borderRadius: "1.1em 0 0 1.1em",
                  ...(index === rows.length - 1
                    ? { backgroundColor: "#8DD9DE" }
                    : {}),
                  textDecoration: withoutValue ? "underline" : "none",
                  paddingTop: withoutValue ? "15px" : "0",
                  paddingBottom: withoutValue ? "5px" : "0",
                }}
              >
                {label}
              </td>
              {
                !withoutValue &&
                <td
                  style={{
                    textAlign: "center",
                    color: value < 0 ? "#FF0000" : "#3A3A3A",
                    fontSize: "16px",
                    paddingRight: "1ch",
                    ...(index === rows.length - 1
                      ? { backgroundColor: "#8DD9DE", fontWeight: "bold" }
                      : { fontWeight: "normal" })
                  }}
                >
                  {formatSpecific(value, label)}
                </td>
              }
            </tr>,
            index === rows.length - 1 ? (
              <tr style={{ height: "1em" }}>
                <td />
                <td />
                <td />
              </tr>
            ) : null
          ])
        )
      )}
    </tbody>
  </table>
);

export default MoneyTable;



// WEBPACK FOOTER //
// ./src/components/analysis/MoneyTable.js